interface ApplePodcastMetaData {
  source: string;
  headline: string;
  description: string;
  audioLink: string;
  imageLink: string;
}

export const getApplePodcastMetaData = async (url: string): Promise<ApplePodcastMetaData> => {
  const response = await fetch('https://n8n.tchop.live/webhook/apple-podcast-meta', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  });

  return await response.json();
};
